import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { REVOKE_CONFIGURATION, REVOKE_CONFIGURATION_SUCCESS, REVOKE_CONFIGURATION_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* revokeConfiguration({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/configurations/benefit-type/airport-transfer/revoke/${payload?.id}`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: REVOKE_CONFIGURATION_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: REVOKE_CONFIGURATION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: REVOKE_CONFIGURATION_ERROR, payload: error });
  }
}

export function* watchrevokeConfiguration() {
  yield takeEvery(REVOKE_CONFIGURATION, revokeConfiguration);
}

function* revokeConfigurationSaga() {
  yield all([fork(watchrevokeConfiguration)]);
}

export default revokeConfigurationSaga;
